// extracted by mini-css-extract-plugin
export var container = "Tabs-module--container--a7605";
export var tab = "Tabs-module--tab--e5b94";
export var active = "Tabs-module--active--01778";